import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "Department", label: "Department" },
  { field: "U/O Charge Labour on Cost (A)", label: "U/O Charge Labour on Cost (A)" },
  { field: "Diff. Between Time Sheet & Master Sheet (B)", label: "Diff. Between Time Sheet & Master Sheet (B)" },
  { field: "Total of A+B", label: "Total of A+B" },
  { field: "U/O Charge Store on Cost ", label: "U/O Charge Store on Cost " },
 
];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>




        </TableHead>

        <TableBody>
          {rows.map((row, index) => {
          // const total=90;
            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                <TableCell colSpan={1} align="left">{row["DIVISIONTYPE"]}</TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row["U/O CHARGE LABOUR ON COST (A)"]} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row["ENGA - TIMESHEET(B)"]} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={row["TOTAL OF A+B"]} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={row["U/O ON COST STORE"]} />
                </TableCell>

              


              </TableRow>



            );
          })}






          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={1} align="right">
                Total Amount
              </TableCell>



              <TableCell align="right">
                <CurrencyCell value={totals.A} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.B} />
              </TableCell>

              <TableCell align="right">
                
              </TableCell>

               <TableCell align="right">
                <CurrencyCell value={totals.D} />
              </TableCell>

          
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}